import { Controller } from "@hotwired/stimulus"

const RESTORE_MS = 1600
const COPIED_ICON = "fa-solid fa-check"
const FAILED_ICON = "fa-solid fa-triangle-exclamation text-red-600"

export default class extends Controller {
  static targets = ["icon"]
  static values = { url: String }

  async copy() {
    if (!this.urlValue) return

    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.flash(COPIED_ICON)
    } catch (error) {
      console.warn("[copy-link] copy failed:", error)
      this.flash(FAILED_ICON)
    }
  }

  flash(className) {
    if (!this.hasIconTarget) return

    const icon = this.iconTarget
    if (icon.dataset.restoreIcon) return

    icon.dataset.restoreIcon = icon.className
    icon.className = className

    setTimeout(() => {
      icon.className = icon.dataset.restoreIcon
      delete icon.dataset.restoreIcon
    }, RESTORE_MS)
  }
}
